export enum RegImportAction {
  UPDATE_IMPORT_DATA = '[regimport] UPDATE_IMPORT_DATA',
  UPDATE_IMPORT_DATA_LAYERS = '[regimport] UPDATE_IMPORT_DATA_LAYERS',
  UPDATE_READ_VALIDATE_DATA = '[regimport] UPDATE_READ_VALIDATE_DATA',
  UPDATE_CONNECT_VALIDATE_DATA = '[regimport] UPDATE_CONNECT_VALIDATE_DATA',
  UPDATE_IMPORT_ACTION_DATA = '[regimport] UPDATE_IMPORT_ACTION_DATA'
}
